import { DsquaresLogo } from "src/assets/Icons";
import UserPoints from "../../UserPoints/UserPoints";
import ModulesMenuDrawer from "../components/ModulesMenuDrawer";
import { Link } from "react-router-dom";

export default function NavBarMob() {
  return (
    <div className="flex items-center justify-between p-4 bg-background-default w-full gap-2">
      <div className="flex-1">
        <Link className="flex h-11 items-center justify-start" to="/">
          <DsquaresLogo className="aspect-auto h-full" />
        </Link>
      </div>
      <div className="flex flex-1 items-center justify-center">
        <UserPoints />
      </div>
      <ModulesMenuDrawer />
    </div>
  );
}
